var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "mb-2 col-md-6" },
        [
          _c("el-input", {
            attrs: {
              value: _vm.pending,
              clearable: _vm.clearable,
              placeholder: _vm.placeholder,
            },
            on: { input: _vm.onChange },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }